import { Inline, LinkButton, Stack, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import OptInCheckbox from './OptInCheckbox';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  align-items: flex-start;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  padding: 8px;
`;
const infoStyles = css`
  align-items: flex-start;
  display: flex;
  flex: 1;
  gap: 4px;
  min-width: 200px;
`;
const SegmentPassCard = ({
  segment,
  index,
  labels,
  onToggle,
  onSeeDetails
}) => {
  var _segment$loungeInfo;
  const airport = segment.departureAirport;
  const loungeName = (_segment$loungeInfo = segment.loungeInfo) === null || _segment$loungeInfo === void 0 ? void 0 : _segment$loungeInfo.loungeName;
  const checkboxId = `${airport}-${index}`;
  return /*#__PURE__*/_jsxs("div", {
    className: rowStyles,
    "data-testid": `segment-pass-card-${checkboxId}`,
    children: [/*#__PURE__*/_jsxs("div", {
      className: infoStyles,
      children: [/*#__PURE__*/_jsx(OptInCheckbox, {
        checked: segment.selected,
        id: checkboxId,
        label: airport,
        onToggle: () => onToggle(index)
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: 4,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: airport
        }), loungeName && /*#__PURE__*/_jsx(Text, {
          variant: "14",
          children: loungeName
        }), onSeeDetails && /*#__PURE__*/_jsx(LinkButton, {
          onClick: () => onSeeDetails(segment),
          children: labels.seeDetails
        })]
      })]
    }), /*#__PURE__*/_jsx(Inline, {
      alignY: "center",
      spacing: 16,
      children: /*#__PURE__*/_jsx(Text, {
        variant: "14-bold",
        children: priceUtils.formatPrice(segment.displayPriceRaw)
      })
    })]
  });
};
export default SegmentPassCard;
//# sourceMappingURL=SegmentPassCard.js.map